import styled, { css } from 'styled-components';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
/**
 * ReceiptInfoBlock
 */
export const receiptInfoBlockStyles = ({ theme, $colorContext, }) => css `
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: ${pxToRem(theme.spacing[300])};
	border-radius: ${pxToRem(theme.borderRadius.m)};
	background-color: ${$colorContext === 'on-light'
    ? theme.colors.blanc.bgBlock
    : theme.colors.blanc.bgReceipt};
`;
export const StyledReceiptInfoBlock = styled.div `
	${receiptInfoBlockStyles}
`;
